import { render } from "./link-company.vue?vue&type=template&id=3f7712a8"
import script from "./link-company.vue?vue&type=script&lang=js"
export * from "./link-company.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__